import { FitType, LayoutType, SizeType } from '@/domains/asset';

export const DEFAULT_LAYOUT_TYPE = 'GRID' as LayoutType;
export const DEFAULT_SIZE_TYPE = 'LANDSCAPE' as SizeType;
export const DEFAULT_FIT_TYPE = 'FIT' as FitType;
export const DEFAULT_HIDE_BORDERS = false;
